module.exports = __webpack_public_path__ + "static/media/chat-empty.f86003d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/chat-empty.png
// module id = 1876
// module chunks = 6